import Track from "util/Track";
import Gallery from "webPage/Gallery";

export default function handleTracks() {
    $('.js-track-slider').each(function () {
        let $this = $(this);
        handleTrackGallery($this);
    });
}

function applyMinHeight(gallery, index) {
    let height = gallery.getItem(index).outerHeight();
    gallery.$items.css("min-height", height + "px");
}

function handleGallery($element) {
    let gallery = new Gallery($element, {
        itemClass: "slider__slide",
        itemsClass: "js-slides",
        animationDuration: 300,
    });

    gallery.showItem(0);
    gallery.getItem(0).addClass('slider__slide--active');

    gallery.on('transitionStart', ({from, to, direction}) => {
        applyMinHeight(gallery, to);
    });

    return gallery;
}

function handleTrackGallery($element) {

    let track = new Track($element, {
        disableButtons: false,
    });

    let gallery = null;

    let max_width = $element.data('max-width');
    let min_width = $element.data('min-width');

    if ('undefined' !== typeof max_width) {
        max_width = parseInt(max_width);
    }

    if ('undefined' !== typeof min_width) {
        min_width = parseInt(min_width);
    }

    if (max_width > 0 || min_width > 0) {

        if ($element.is('.js-mobile-gallery')) {
            gallery = handleGallery($element);
        }

        handleResize(track, max_width, min_width, gallery);

        $(window).on('resize', () => {
            handleResize(track, max_width, min_width, gallery);
        });
    }
}

function handleResize(track, max_width, min_width, gallery) {
    let window_width = $('html').outerWidth();

    if ('undefined' !== typeof max_width && window_width >= max_width) {
        track.disable();

        if (gallery !== null) {
            gallery.enable();
        }
    } else if ('undefined' !== typeof min_width && window_width <= min_width) {
        track.disable();

        if (gallery) {
            gallery.enable();
        }
    } else {
        track.enable();

        if (gallery) {
            gallery.disable();
            gallery.$items.css("min-height", "0px");
        }
    }

    if (gallery && gallery.enabled) {
        applyMinHeight(gallery, gallery.getActiveIndex());
    }
}